import { useState } from 'react';
import { Button, Form, Input, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import logo from '../assets/logo.jpg';
import type { CloudUser } from '../auth/AuthContext';
import { apiRequest, jsonBody } from '../platform/api';
import { SiteFooter } from '../components/layout/SiteFooter';

export function Login({ onSuccess }: { onSuccess: (user: CloudUser) => void }) {
  const [submitting, setSubmitting] = useState(false);

  const submit = async (values: { username: string; password: string }) => {
    setSubmitting(true);
    try {
      const response = await apiRequest<{ user: CloudUser }>('/api/auth/login', {
        method: 'POST',
        ...jsonBody(values),
      });
      onSuccess(response.user);
    } catch (error) {
      message.error(error instanceof Error ? error.message : '登录失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="auth-shell">
      <section className="auth-panel">
        <div className="auth-brand">
          <img src={logo} alt="" />
          <div>
            <h1>AI Fashion Studio</h1>
            <p>服装视觉生产工作台</p>
          </div>
        </div>
        <div className="auth-heading">
          <h2>登录</h2>
          <p>使用管理员分配的账号进入工作台</p>
        </div>
        <Form layout="vertical" size="large" onFinish={submit} requiredMark={false}>
          <Form.Item name="username" label="账号" rules={[{ required: true, message: '请输入账号' }]}>
            <Input prefix={<UserOutlined />} autoComplete="username" autoFocus />
          </Form.Item>
          <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={submitting} block>进入工作台</Button>
        </Form>
      </section>
      <SiteFooter />
    </main>
  );
}
